import { ReloadOutlined } from "@ant-design/icons"
import { Button, Card, Table } from "antd"
import { useCallback, useMemo } from "react"
import { Link } from "react-router-dom"
import type { ReferenceEdition } from "../../types/regulatory"
import { allCatalogPages, regulatoryApi } from "../../utils/regulatoryApi"
import { normalizeString } from "../../utils/users"
import { CatalogFrame, JsonDetails, ResourceState, SearchInput } from "./components/CatalogUI"
import { textValue } from "./format"
import { useCatalogFilters, useCatalogResource } from "./useCatalog"
export function ReferencesPage() {
  const { filters, page, update } = useCatalogFilters()
  const resource = useCatalogResource(
    useCallback((signal) => allCatalogPages(regulatoryApi.references, signal), []),
  )
  const rows = useMemo(
    () =>
      (resource.data ?? []).filter((row) =>
        normalizeString(JSON.stringify(row)).includes(normalizeString(filters.q ?? "")),
      ),
    [resource.data, filters.q],
  )
  return (
    <CatalogFrame
      title="Références et éditions"
      extra={
        <Button onClick={resource.reload} icon={<ReloadOutlined />}>
          Actualiser
        </Button>
      }
    >
      <SearchInput
        value={filters.q ?? ""}
        onSearch={(value) => update({ q: value })}
        placeholder="Rechercher une référence ou une édition"
      />
      <ResourceState {...resource} retry={resource.reload}>
        <Card>
          <Table<ReferenceEdition>
            rowKey="uuid"
            dataSource={rows}
            pagination={{
              current: page,
              pageSize: filters.limit,
              total: rows.length,
              onChange: (next, size) => update({ page: next, limit: size }),
            }}
            columns={[
              { title: "Désignation complète", dataIndex: "designation" },
              { title: "Édition", render: (_value, row) => textValue(row.edition) },
              {
                title: "Sources",
                render: () => <Link to="/regulatory/sources">Consulter les documents sources</Link>,
              },
            ]}
            expandable={{
              expandedRowRender: (row) => (
                <JsonDetails
                  value={{
                    referenceUuid: row.referenceUuid,
                    editionUuid: row.uuid,
                    ...row.metadata,
                  }}
                />
              ),
            }}
          />
        </Card>
      </ResourceState>
    </CatalogFrame>
  )
}
